import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Circles from "../images/circles.svg"

const ProductHeader = ({ title, subtitle }) => (
  <div class="flex flex-col relative max-w-screen-sm mx-auto h-48 md:h-96 items-center justify-center text-center">
    <img src={Circles} className="w-auto h-full absolute top-0 z-0" />
    <h1 className="text-3xl md:text-6xl font-semibold text-indigo-100 w-full leading-tight">
      {title}
    </h1>
    <h5 className="uppercase text-indigo-100 text-sm md:text-lg pt-4">
      {subtitle}
    </h5>
  </div>
)

ProductHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

ProductHeader.defaultProps = {
  title: "",
  subtitle: "",
}

export default ProductHeader
